// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"284":"c371cf0e","939":"50e85302"}[chunkId] + ".js";
};